import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import GetYourFreeQuoteIn4SimpleSteps from "./sections/GetYourFreeQuoteIn4SimpleSteps";
import BuildingYourScrantonDreamHome from "./sections/BuildingYourScrantonDreamHome";
import CustomerReviews from "./sections/CustomerReviews";
import TrustedPlumbingPartner from "./sections/TrustedPlumbingPartner";
import TheLondonTilingStandard from "./sections/TheLondonTilingStandard";
import OurTilingExpertise from "./sections/OurTilingExpertise";
import ResidentialServices from "./sections/ResidentialServices";
import RecentLondonTransformations from "./sections/RecentLondonTransformations";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import StartYourRenovation from "./sections/StartYourRenovation";
import TheWaterproofingEdge from "./sections/TheWaterproofingEdge";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BuildingYourScrantonDreamHome />
      <GetYourFreeQuoteIn4SimpleSteps />
      <TrustedPlumbingPartner />
      <TheLondonTilingStandard />
      <OurTilingExpertise />
      <ResidentialServices />
      <TheWaterproofingEdge />
      <RecentLondonTransformations />
      <ClientSuccessStories />
      <StartYourRenovation />
      <CustomerReviews />
      <Footer />
    </div>;
}